import React from "react";
import "../styles/styles.css";

function HeroSection() {
  return (
    <section className="hero-section">
      {/* Texture Overlay for that premium paper feel */}
      <div className="grain-overlay"></div>

      <div className="hero-container">
        <div className="hero-text-side">
          <div className="badge">Version 1.0 — Now Live</div>
          <h1>
            Capture the <br />
            <span className="italicize">unspoken</span> margin.
          </h1>
          <p>
            The best insights happen between the lines. Margin is a sensory
            vault for the modern reader—transforming fleeting thoughts into a
            permanent library of you.
          </p>

          <div className="hero-cta-group">
            <div className="store-card">
              <img src="./assets/iosqrdots.png" alt="QR" className="qr-stamp" />
              <div className="store-info">
                <span>Soon Available</span>
                <strong>iOS App Store</strong>
              </div>
            </div>
            <a
              href="https://play.google.com/store/apps/details?id=com.niciii.margin"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="store-card" style={{ cursor: "pointer" }}>
                <img
                  src="./assets/androiddots.jpg"
                  alt="QR"
                  className="qr-stamp"
                />
                <div className="store-info">
                  <span>Available on</span>
                  <strong>Google Play</strong>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className="hero-visual-side">
          {/* This is where your app mockup or a high-end 3D book stack goes */}
          <div className="floating-mockup">
            <div className="mockup-screen">
              <div className="voice-wave-animation">
                {/* Add a style tag or a class that uses the brand-pop */}
                <span style={{ backgroundColor: "var(--brand-pop)" }}></span>
                <span style={{ backgroundColor: "var(--brand-pop)" }}></span>
                <span style={{ backgroundColor: "var(--brand-pop)" }}></span>
              </div>
            </div>
            <div className="floating-element note-1">
              “Memory is the scribe...”
            </div>
            <div className="floating-element note-2">Chapter 4 Reflection</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
